module.exports = __webpack_public_path__ + "img/file.9093b206.png";